<template>
  <header>
    <a href="https://demos.co.uk">
      <img alt="demos logo" class="demos-logo" src="../assets/demos-logo.png" />
    </a>
    <a href="https://brand.legalandgeneral.com/building-infrastructure/how-satisfied-are-people-in-your-area">
      <img
        alt="legal and general logo"
        class="lg-logo"
        src="../assets/legal-and-general-logo-white.png"
      />
    </a>
  </header>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style scoped>
header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 40px 10px;
  background-color: #1d3336;
}

.demos-logo {
  height: 2.5rem;
  margin: 1rem;
}

.lg-logo {
  height: 5rem;
  margin-right: 1rem;
}
</style>
